module.exports = __webpack_public_path__ + "static/img/wxqr.8ba2a027.png";